import { useUpdateDefaultVisualization as updateVisulization } from '~map-preview/queries/useUpdateDefaultVisualization'
import { useMapSettingsStore } from '~map-preview/states/mapSettings'

export const useUpdateDefaultVisualization = () => {
  const { setDefaultVisualization } = useMapSettingsStore()
  const updateDefaultVisualizationMutation = updateVisulization()
  const handleChange = async (payload) => {
    setDefaultVisualization({
      [payload.type]: payload
    })
    await updateDefaultVisualizationMutation.mutateAsync({
      input: {
        [payload.type]: payload
      }
    })
  }
  return {
    update: handleChange
  }
}
